'use client'

import * as React from 'react'
import { format, isValid, parse } from 'date-fns'
import { Calendar } from '@/components/ui/Calendar'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/Popover'
import { Input } from './Input'
import { CalendarDaysIcon } from '@heroicons/react/16/solid'

export type DatePickerProps = React.ComponentProps<typeof Calendar>

type EnhancedDatePickerProps = DatePickerProps &
  React.ComponentProps<typeof Input>

export default function DatePicker({
  value: value,
  onSelect: setSelectedDate,
  selected: selectedDate,
  placeholder,
  status,
                                     inputDisabled,
  ...props
}: EnhancedDatePickerProps) {
  const inputRef = React.useRef(null)

  const [inputValue, setInputValue] = React.useState(
    format(value, 'dd/MM/yyyy'),
  )

  const handleDayPickerSelect = (value: Date | undefined) => {
    setSelectedDate(format(value, 'yyyy-MM-dd'))
    // setMonth(date)
    inputRef.current?.click()
    inputRef.current?.focus()
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value) // keep the input value in sync

    const parsedDate = parse(e.target.value, 'dd/MM/yyyy', new Date())

    if (isValid(parsedDate)) {
      setSelectedDate(parsedDate)
      // setMonth(parsedDate)
    } else {
      setSelectedDate(undefined)
    }
  }

  React.useEffect(() => {
    setInputValue(format(value, 'dd MMMM yyyy'))
  }, [value])

  return (
    <Popover modal>
      <PopoverTrigger className="w-full" data-slot="control">
        <Input
            disabled={inputDisabled}
          value={inputValue || format(new Date(), 'dd MMMM yyyy')}
          onChange={handleInputChange}
          ref={inputRef}
          placeholder={placeholder}
          leadingIcon={<CalendarDaysIcon />}
          status={status}
          // {...props}
        />
      </PopoverTrigger>
      {!inputDisabled && (
          <PopoverContent className="w-auto p-0">
            <Calendar
                mode="single"
                selected={selectedDate}
                onSelect={handleDayPickerSelect}
                initialFocus
                {...props}
            />
          </PopoverContent>
      )}

    </Popover>
  )
}
